const faqs = [
	{
		title: 'Super Mom Champions',
		subtitle:
			'A mother of a special needs child is the best therapist we know of. So, we strive to hire and rigorously train single mothers of special needs children, with a path to partnership in the clinic so that no mother must struggle with conflicting priorities of childcare, financial security & career.'
	},
	{
		title: 'A family-centered care team',
		subtitle:
			'Every child is special and unique. Parents know the child better than anyone. So, we insist on an active role of parents in their child’s development. We seek parent’s perspective and input to collectively give a child the best care possible.'
	},
	{
		title: 'Community Approach',
		subtitle:
			'Not every child is able to come to our clinic. That’s why we serve our communities outside of our walls with community sessions, community events, at-home & telehealth support, sponsored care & legislative advocacy.'
	},
	{
		title: 'High Quality, Constant Improvement',
		subtitle:
			'We are the only high-touch clinic with neuroscientists analyzing, guiding, and working closely with care teams – BCBA and therapists. We have the resources, experience, education and most importantly ‘the heart’ to care for your child.'
	},
	{
		title: 'Age-benchmarked lifetime focus',
		subtitle:
			'At SimSouls, we are by your side at every step of your child’s life journey. To achieve this goal, we aspire to offer age appropriate and comprehensive support that includes - developmental screening & therapies, parent ed programs, specialized nannies/babysitters, day care, special ed school, summer camp and group living.'
	},
	{
		title: 'Most updated, research driven therapy',
		subtitle: 'Our top-notch experts deploy the latest in research and innovation to maximie benefit to your child'
	}
];

export default faqs;
